// Khai Bảo (ITEMS §9, UI_SPEC §12): nghi thức mở món Tiên+ từ Rương Chưa Mở. Chỉ trạng thái phù du.
import { signal, computed } from '@preact/signals';
import type { ItemInstance } from '@data/items/types';
import { inventory, openSealed } from './inventory';

const _uid = signal<string | null>(null);
/** Món đang diễn Khai Bảo (chưa vào túi). */
export const revealing = computed<ItemInstance | null>(() => {
  const uid = _uid.value;
  return uid ? (inventory.value.unopened.find((i) => i.uid === uid) ?? null) : null;
});

export function startReveal(uid: string): void {
  if (inventory.peek().unopened.some((i) => i.uid === uid)) _uid.value = uid;
}

/** Bấm "Nhận": món vào túi, nghi thức đóng. */
export function finishReveal(): void {
  const uid = _uid.peek();
  _uid.value = null;
  if (uid) openSealed(uid);
}
